var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuRightArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.77328 5.38959C8.52811 5.1466 8.13239 5.14837 7.8894 5.39353C7.64642 5.63869 7.64818 6.03442 7.89335 6.27741L9.36249 7.73349C9.95873 8.32444 10.3677 8.73114 10.6445 9.07575C10.9133 9.4105 11.0055 9.62551 11.0301 9.81808C11.0455 9.93899 11.0455 10.0613 11.0301 10.1823C11.0055 10.3748 10.9133 10.5898 10.6445 10.9246C10.3677 11.2692 9.95873 11.6759 9.36249 12.2668L7.89335 13.7229C7.64818 13.9659 7.64642 14.3616 7.8894 14.6068C8.13239 14.852 8.52811 14.8537 8.77328 14.6107L10.2689 13.1284C10.8322 12.5701 11.2926 12.1138 11.6191 11.7073C11.9586 11.2845 12.2044 10.8554 12.2701 10.3403C12.2988 10.1144 12.2988 9.88588 12.2701 9.66003C12.2044 9.14493 11.9586 8.71582 11.6191 8.29305C11.2926 7.88648 10.8322 7.4302 10.2689 6.87191L8.77328 5.38959Z",
    fill: "#062A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRightArrowIcon);
export default __webpack_public_path__ + "static/media/Menu-RightArrowIcon.099da8e66353d9cd60da4c5838cc1b95.svg";
export { ForwardRef as ReactComponent };